<template>
  <div class="">
    <div v-if="!store.isBillingEnabled" class="max-w-7xl mx-auto my-5">
      <div class="px-1 md:px-20">
        <div class="mt-8  pb-16 sm:mt-12 sm:pb-20 lg:pb-28">
          <div class="relative">
            <div class="absolute inset-0 h-1/2 bg-gray-100"></div>
            <div class="relative max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
              <div
                class="max-w-lg mx-auto rounded-lg shadow-lg overflow-hidden lg:max-w-none lg:flex"
              >
                <div class="bg-white px-6 py-8 lg:p-12">
                  <h3
                    class="text-2xl leading-8 font-extrabold text-gray-900 sm:text-3xl sm:leading-9"
                  >
                    Automatically recover abandoned carts
                  </h3>
                  <p class="mt-6 text-base leading-6 text-gray-500">
                    With our automation, you don't have to send the messages
                    manually. We do it for you automatically and we precisely
                    message them in 15 min after they abandoned, which is to be
                    the right timing for recovery.
                  </p>
                  <div class="mt-8">
                    <div class="flex items-center">
                      <h4
                        class="flex-shrink-0 pr-4 bg-white text-sm leading-5 tracking-wider font-semibold uppercase text-indigo-600"
                      >
                        What's included
                      </h4>
                      <div class="flex-1 border-t-2 border-gray-200"></div>
                    </div>
                    <ul
                      class="mt-8 lg:grid lg:grid-cols-2 lg:gap-x-8 lg:gap-y-5"
                    >
                      <li class="flex items-start lg:col-span-1">
                        <div class="flex-shrink-0">
                          <!-- Heroicon name: check-circle -->
                          <svg
                            class="h-5 w-5 text-green-400"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                              clip-rule="evenodd"
                            />
                          </svg>
                        </div>
                        <p class="ml-3 text-sm leading-5 text-gray-700">
                          <a
                            class=""
                            href="https://docs.google.com/spreadsheets/d/1Bc8J7Majk2spWA7S8Lf6VV-0mGF11nYpKKedrv44hyc/edit?usp=sharing"
                            target="blank"
                            >Pay per message based on country
                          </a>
                        </p>
                      </li>
                      <li class="mt-5 flex items-start lg:col-span-1 lg:mt-0">
                        <div class="flex-shrink-0">
                          <!-- Heroicon name: check-circle -->
                          <svg
                            class="h-5 w-5 text-green-400"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                              clip-rule="evenodd"
                            />
                          </svg>
                        </div>
                        <p class="ml-3 text-sm leading-5 text-gray-700">
                          Sends recovery message within 15 min
                        </p>
                      </li>
                      <li class="mt-5 flex items-start lg:col-span-1 lg:mt-0">
                        <div class="flex-shrink-0">
                          <!-- Heroicon name: check-circle -->
                          <svg
                            class="h-5 w-5 text-green-400"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                              clip-rule="evenodd"
                            />
                          </svg>
                        </div>
                        <p class="ml-3 text-sm leading-5 text-gray-700">
                          High converting message templates in 9 languages
                        </p>
                      </li>
                      <li class="mt-5 flex items-start lg:col-span-1 lg:mt-0">
                        <div class="flex-shrink-0">
                          <!-- Heroicon name: check-circle -->
                          <svg
                            class="h-5 w-5 text-green-400"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                              clip-rule="evenodd"
                            />
                          </svg>
                        </div>
                        <p class="ml-3 text-sm leading-5 text-gray-700">
                          Priority customer support
                        </p>
                      </li>
                      <li class="mt-5 flex items-start lg:col-span-1 lg:mt-0">
                        <div class="flex-shrink-0">
                          <!-- Heroicon name: check-circle -->
                          <svg
                            class="h-5 w-5 text-green-400"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                              clip-rule="evenodd"
                            />
                          </svg>
                        </div>
                        <p class="ml-3 text-sm leading-5 text-gray-700">
                          Send Order Confirmation messages
                        </p>
                      </li>
                      <li class="mt-5 flex items-start lg:col-span-1 lg:mt-0">
                        <div class="flex-shrink-0">
                          <!-- Heroicon name: check-circle -->
                          <svg
                            class="h-5 w-5 text-green-400"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                              clip-rule="evenodd"
                            />
                          </svg>
                        </div>
                        <p class="ml-3 text-sm leading-5 text-gray-700">
                          Send Order Shipment updates
                        </p>
                      </li>
                      <li class="mt-5 flex items-start lg:col-span-1 lg:mt-0">
                        <div class="flex-shrink-0">
                          <!-- Heroicon name: check-circle -->
                          <svg
                            class="h-5 w-5 text-green-400"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                              clip-rule="evenodd"
                            />
                          </svg>
                        </div>
                        <p class="ml-3 text-sm leading-5 text-gray-700">
                          Send COD Confirmation messages
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
                <div
                  class="py-8 px-6 text-center bg-gray-50 lg:flex-shrink-0 lg:flex lg:flex-col lg:justify-center lg:p-12"
                >
                  <p class="text-lg leading-6 font-medium text-gray-900">
                    Simple pricing
                  </p>
                  <div
                    class="mt-4 flex items-center justify-center text-5xl leading-none font-extrabold text-gray-900"
                  >
                    <span>
                      $9.99
                    </span>
                    <span
                      class="ml-3 text-xl leading-7 font-medium text-gray-500"
                    >
                      USD
                    </span>
                  </div>

                  <div class="mt-6">
                    <div class="rounded-md shadow">
                      <a
                        class="flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-gray-900 hover:bg-gray-800 focus:outline-none focus:shadow-outline transition duration-150 ease-in-out cursor-pointer"
                        @click="choosePlan('vip')"
                      >
                        Start 14 day trial
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="max-w-screen-xl mx-auto py-12 px-4 sm:py-16 sm:px-6 lg:px-8"
          >
            <div class="max-w-3xl mx-auto">
              <h2
                class="text-center text-3xl leading-9 font-extrabold text-gray-900 sm:text-4xl sm:leading-10"
              >
                Frequently asked questions
              </h2>
            </div>
            <AccordianItem
              v-for="(faq, index) of faqs"
              :key="index"
              :title="faq.title"
              :content="faq.content"
            />
          </div>
        </div>
      </div>
    </div>
    <div class=" sm:block" v-else>
      <div class="flex ">
        <Sidebar />
        <div class="max-w-5xl mx-auto ">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AccordianItem from "../components/Common/AccordianItem";

import Sidebar from "../components/Automation/Sidebar";

export default {
  name: "FullyAutomated",
  components: {
    AccordianItem,
    Sidebar
  },
  data() {
    return {
      config: {},
      templates: [],
      isLoading: true,
      faqs: [
        {
          title: "What are all the languages available?",
          content:
            "You can send messages in English, Portguese, Spanish, Italian, French, Indonesian, German, Arabic, Turkish, Hebrew and Dutch"
        },
        {
          title: "Will I be charged for failed messages?",
          content:
            "No, if that’s not a WhatsApp number or if we couldn’t deliver a message we wouldn’t count that message."
        },
        {
          title: "Will the automated messages go from my number?",
          content:
            "WhatsApp needs a Business API approval and hence it will be sent from one of our numbers, but we will also add your number in all messages so they can reach you with a click."
        },
        {
          title: "Can I send WhatsApp messages to everybody?",
          content:
            "You can only send it to people who have opted in via checkout."
        }
      ]
    };
  },
  computed: {
    store() {
      return this.$store.getters.getStore;
    }
  },
  created() {},
  methods: {
    choosePlan(plan) {
      this.$store
        .dispatch("selectPlan", { requestParams: { plan } })
        .then(response => {
          if (response.confirmationUrl) {
            if (window.top) {
              window.top.location = response.confirmationUrl;
            } else {
              window.location.href = response.confirmationUrl;
            }
            return;
          }
          if (response.ok) {
            this.$router.push({ name: "Home" });
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
